<!--
	Legend panel for the SafeSystem Prioritize tab.
-->
<script lang="ts">
	import DataNotAvailable from '#lib/components/DataNotAvailable.svelte';
	import LegendSection from '#lib/components/LegendSection.svelte';
	import LegendItems from './LegendItems.svelte';
	import { legendStore } from '#lib/stores/legendStore.svelte.js';
	import { geodataStore } from '#lib/stores/geodataStore.svelte.js';

	interface Props {
		heading: string;
		labels: Record<string, string>;
	}
	const { heading, labels }: Props = $props();

	// Both apps key Prioritize as 'Prioritize'; available when its ILayerSource is non-null.
	const prioritizeAvailable = $derived(
		(geodataStore.systemData as { Prioritize?: { Prioritize?: unknown } }).Prioritize?.Prioritize !=
			null
	);
	const prioritizeLegend = $derived(legendStore.layers.find((l) => l.systemId === 'Prioritize'));
</script>

<div class="legendBox">
	<LegendSection {heading}>
		{#if !prioritizeAvailable || !prioritizeLegend}
			<DataNotAvailable />
		{:else}
			<LegendItems legend={prioritizeLegend} patch="square" {labels} />
		{/if}
	</LegendSection>
</div>
